var _circle, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgRightArrow = function SvgRightArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    r: 19.5,
    transform: "matrix(-1 0 0 1 20 20)",
    stroke: "#343741"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.694 14.615 23.078 20l-5.384 5.384",
    stroke: "#343741"
  })));
};

export { SvgRightArrow as ReactComponent };
export default __webpack_public_path__ + "1b47832cedde6eb5c2cef3dd3b26218e.svg";